module.exports = __webpack_public_path__ + "img/Path.e361f2b2.svg";